import Hero from './components/Hero';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import WhyTrust from './components/WhyTrust';
import SuccessStories from './components/SuccessStories';
import Benefits from './components/Benefits';
import FounderBio from './components/FounderBio';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <HowItWorks />
      <WhyTrust />
      <SuccessStories />
      <Benefits />
      <FounderBio />
      <CTA />
      <Footer />
    </div>
  );
}
